/**
 * Web announces the confirmation through the `role="status"` live region on the
 * message itself, so there is nothing to announce imperatively here.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const announceVerified = (message: string): void => {};

export default announceVerified;
